<template>
  <div class="box">
    <Row class="mb-40">
      <Col span="24" class="box-header">
        <h2>Транзакции</h2>
      </Col>
      <Col span="24" class="box-header-filter">
        <Menu
          mode="horizontal"
          :active-name="defaultFilter"
          @on-select="selectFilter"
        >
          <MenuItem name="year" class="menu-item">
            Год
          </MenuItem>
          <MenuItem name="month" class="menu-item">
            Месяц
          </MenuItem>
          <MenuItem name="week" class="menu-item">
            Неделя
          </MenuItem>
          <MenuItem name="day" class="menu-item">
            День
          </MenuItem>
        </Menu>
      </Col>
    </Row>

    <Row class="mb-30" type="flex" align="middle">
      <Col span="12" class="box-label">
        <span>Средний чек:</span>
      </Col>
      <Col span="12" class="box-value">
        <span>{{ formatNumber(average_sum) }} {{ $store.state.currency }}</span>
      </Col>
    </Row>
    <Row type="flex" align="middle">
      <Col span="12" class="box-label">
        <span>Количество чеков:</span>
      </Col>
      <Col span="12" class="box-value">
        <span>{{ formatNumber(count) }}</span>
      </Col>
    </Row>

    <!--    <h2>Средний чек (продажа)</h2>-->
    <!--    <h1 class="average_order">{{ formatNumber(data) }} {{ $store.state.currency }}</h1>-->
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
    import { base_url } from "../../http";
    import { formatNumber } from "../../base/base_func.js";
    export default {
        name: "averageOrderChart2",
        data() {
            return {
                loading: true,
                average_sum: "",
                count: "",
                defaultFilter: "month"
            };
        },
        // Загружаем данные для таблицы
        methods: {
            selectFilter: function(period) {
                // console.log(name);
                this.fetchData(period);
            },
            fetchData: function(period) {
                this.loading = true;
                this.lastDraw++;
                let url = `${base_url}/charts/average_order/`;
                this.$http
                    .get(url, {
                        params: {period: period}
                    })
                    .then(result => {
                        this.average_sum = result.data.average_sum;
                        this.count = result.data.count;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            formatNumber(val) {
                return formatNumber(val);
            }
        },
        mounted: function() {
            this.fetchData(this.defaultFilter);
        }
    };
</script>

<style scoped>
  .box {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.24);
    padding: 20px 30px;
    border-radius: 18px;
    position: relative;
  }
  .box-header {
    text-align: left;
    font-weight: bold;
    font-size: 18px;
    padding-bottom: 10px;
  }
  .box-header-filter {
    text-align: right;
    /*font-weight: bold;*/
    /*font-size: 10px !important;*/
    /*color: rgb(141, 141, 141) !important;*/
  }
  .ivu-menu {
    z-index: 1;
  }
  .ivu-menu-horizontal {
    height: auto;
    line-height: 1.2;
    margin-bottom: 20px;
  }
  .menu-item {
    font-size: 16px;
    line-height: 30px !important;
    padding: 0 5px !important;
    float:right;
  }
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active,
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover,
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active,
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
    /*color: #2d8cf0;*/
    /*border-bottom: None;*/
    /*font-weight: bold;*/
    color: rgba(37, 215, 126, 1);
    border-bottom: unset;
  }
  .ivu-menu-horizontal.ivu-menu-light::after {
    background: white;
  }
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item,
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu {
    border-bottom: unset;
    /*color: #515a6e;*/
  }
  .ivu-menu-horizontal .ivu-menu-item,
  .ivu-menu-horizontal .ivu-menu-submenu {
    color: #8080809e;
    /*float: left;*/
    /*padding: 0 10px;*/
    /*position: relative;*/
    /*cursor: pointer;*/
    /*z-index: 3;*/
    /*transition: all 0.2s ease-in-out;*/
  }
  .box-label {
    display: inline-block;
    text-align: left;
    font-weight: normal;
    font-size: 18px;
  }

  .box-value {
    display: inline-block;
    text-align: right;
    font-weight: bold;
    font-size: 26px;
  }

  @media screen and (max-width: 1900px) {
    .box-label {
      font-size: 18px;
    }
    .box-value {
      font-size: 22px;
    }
    .menu-item {
      font-size: 15px;
    }
  }
  @media screen and (max-width: 1500px) {
    .box-label {
      font-size: 15px;
    }
    .box-value {
      font-size: 20px;
    }
    .menu-item {
      font-size: 14px;
    }
  }

  @media screen and (max-width: 991px) {
    h2 {
      font-size: 18px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/apps/home/averageOrderChart2.vue